export default () => ({
    loading : false,
    events : [],
    event : {}
})
  